import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Button, Progress } from "@h3/antd-vue";
import { formApi, listApi as Application, listParams } from "@cloudpivot/api";
let DataImportStatus = class DataImportStatus extends Vue {
    get isHalfSuccess() {
        return this.status === listParams.ImportResult.PartialSuccess;
    }
    get showFailMessage() {
        return (this.status === listParams.ImportResult.DataNumExceed ||
            this.status === listParams.ImportResult.DataColumnError ||
            this.isUnspecified ||
            this.isTemplateEmpty);
    }
    get getActive() {
        // ;
        return this.status === listParams.ImportResult.None;
    }
    get matchError() {
        return this.status === listParams.ImportResult.DataColumnError;
    }
    get systemError() {
        return this.status === listParams.ImportResult.SystemError;
    }
    get isSuccess() {
        return this.status === listParams.ImportResult.Success;
    }
    get isTemplateEmpty() {
        return this.status === listParams.ImportResult.TemplateEmpty;
    }
    get isUnspecified() {
        return this.status === listParams.ImportResult.Unspecified;
    }
    exportErrorTem() {
        if (!this.errorFile) {
            return;
        }
        this.exportErrorResult(this.errorFile, "错误提示template.xlsx");
    }
    /**
     * 下载模板
     */
    exportTemplate() {
        formApi.exportTemplate(this.sheetParams).then((res) => {
            if (res.errcode === 0) {
                this.exportErrorResult(res.data);
            }
        });
    }
    exportErrorResult(file, customName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // 
            const res = yield Application.downErrorResult(file);
            if ((res.errcode && res.errcode !== 0) || res.byteLength < 100) {
                this.$message.error(this.$t("cloudpivot.list.pc.DownloadFailed"));
            }
            else {
                const blob = new Blob([res], { type: "application/vnd.ms-excel" });
                const stamp = new Date().getMilliseconds();
                let fileName = "";
                if (customName) {
                    fileName = customName;
                }
                else {
                    fileName = "template.xlsx";
                }
                this.downloadFile(blob, fileName);
            }
        });
    }
    downloadFile(blob, fileName) {
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
        }
        else {
            const a = document.createElement("a");
            const url = URL.createObjectURL(blob);
            a.download = fileName;
            a.href = url;
            a.click();
            URL.revokeObjectURL(url);
        }
    }
    handleClick() {
        this.$emit("cancel");
    }
};
tslib_1.__decorate([
    Prop({
        type: Number,
    })
], DataImportStatus.prototype, "percent", void 0);
tslib_1.__decorate([
    Prop({
        type: Number,
        default: 0,
    })
], DataImportStatus.prototype, "successNum", void 0);
tslib_1.__decorate([
    Prop({
        type: Number,
        default: 0,
    })
], DataImportStatus.prototype, "failNum", void 0);
tslib_1.__decorate([
    Prop({
        type: Number,
        default: 0,
    })
], DataImportStatus.prototype, "status", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
    })
], DataImportStatus.prototype, "fileName", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
    })
], DataImportStatus.prototype, "schemaCode", void 0);
tslib_1.__decorate([
    Prop()
], DataImportStatus.prototype, "sheetParams", void 0);
tslib_1.__decorate([
    Prop()
], DataImportStatus.prototype, "errorFile", void 0);
tslib_1.__decorate([
    Prop({
        type: Number,
        default: 0,
    })
], DataImportStatus.prototype, "importSize", void 0);
tslib_1.__decorate([
    Prop({
        type: Object,
        default: {},
    })
], DataImportStatus.prototype, "getSheetImportCount", void 0);
DataImportStatus = tslib_1.__decorate([
    Component({
        name: "data-import-status",
        components: {
            AProgress: Progress,
            AButton: Button,
        },
    })
], DataImportStatus);
export default DataImportStatus;
